import Locale       from 'element-ui/lib/locale'
import Message      from 'element-ui/lib/message'
import MessageBox   from 'element-ui/lib/message-box'
import Notification from 'element-ui/lib/notification'

import loadComponent from './component'
import * as elements from './elements'

const Plugin = {
  install(Vue, config) {
    const options = { size: '', zIndex: 2000, ...config }

    if (options.locale) {
      Locale.use(options.locale)
    }

    if (options.i18n) {
      Locale.i18n(options.i18n)
    }

    Vue.prototype.$ELEMENT = {
      size: options.size,
      zIndex: options.zIndex
    }

    Vue.prototype.$msgbox  = MessageBox
    Vue.prototype.$alert   = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt  = MessageBox.prompt
    Vue.prototype.$notify  = Notification
    Vue.prototype.$message = Message

    Object.values(elements).forEach(Component => {
      const wrapper = loadComponent(Component)
      Vue.component(wrapper.name, wrapper)
    })
  }
}

export default Plugin
